import { AnyAction } from 'redux';
import { Position } from '@synergy/models';

import { RECEIVE_POSITIONS } from '../actions/positions-actions';

export interface PositionsReducerState {
    positions: Position[];
}

const initialPositionsReducerState: PositionsReducerState = {
    positions: [],
};

export const positionsReducer = (
    state: PositionsReducerState = initialPositionsReducerState,
    action: AnyAction
): PositionsReducerState => {
    const { type, ...rest } = action;
    switch (type) {
        case RECEIVE_POSITIONS: {
            return {
                ...state,
                positions: rest['positions'],
            };
        }

        default: {
            return state;
        }
    }
};
